<template>
  <DashboardTopCardContent
    :callToActionButtonText="$t('L_learn_more')"
    @callToActionCallback="goToInvestments"
  >
    <template #main-content>
      <h2 class="text-h2 font-weight-bold text-center">
        {{ $t('L_just_25_month') }}
      </h2>
      <h4 class="text-h4 text-center font-weight-medium">
        {{ $t('L_help_saving_for_retirement') }}
      </h4>
    </template>
  </DashboardTopCardContent>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import DashboardTopCardContent from '../../DashboardTopCardContent.vue';
import type { RouteLocationNormalizedLoaded, Router } from 'vue-router';
import { $t } from '@/i18n/i18n.ts';
import { RouteNames } from '@/router/routeNames.ts';

export default defineComponent({
  name: 'NoInvestmentsTop',
  components: { DashboardTopCardContent },
  methods: {
    $t,
    async goToInvestments(this: { $route: RouteLocationNormalizedLoaded; $router: Router }) {
      await this.$router.push({ name: RouteNames.INVESTMENT_LEARN_MORE });
    },
  },
});
</script>
